import { CSSTransition } from 'react-transition-group';

const classNames = {
  enter: 'PopoverTransition-enter',
  enterActive: 'PopoverTransition-enter--active',
  exit: 'PopoverTransition-exit',
  exitActive: 'PopoverTransition-exit--active',
};

const timeout = 100;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (props: any) => {
  const { children, isVisible } = props;

  return (
    <CSSTransition
      classNames={classNames}
      in={isVisible}
      mountOnEnter={true}
      timeout={timeout}
      unmountOnExit={true}
    >
      {children}
    </CSSTransition>
  );
};
